/**
 * Routes where the header site selector is read-only (locked to All sites).
 * Kept for pages that force All-sites scope while the control is shown elsewhere
 * (or briefly during transitions). Prefer `isSiteSelectorHiddenPath` to hide UI.
 */
const LOCKED_PREFIXES = [
  "/v2/overview",
  "/v2/sites",
  "/v2/findings",
  "/v2/ssl-tls/overview",
];

/**
 * Routes where changing site scope does not refresh page data — hide the filter.
 */
const HIDDEN_PREFIXES = [
  "/v2/overview",
  "/v2/sites",
  "/v2/findings",
  "/v2/ssl-tls/overview",
  "/v2/settings",
  "/v2/reports",
  "/v2/services/waf_configuration",
  "/v2/services/web_application/custom_rules",
];

/**
 * Dashboard bases: root page uses site scope; nested drill-downs pin site via URL
 * and ignore the header — hide the filter only on nested paths.
 */
const HIDDEN_DASHBOARD_NESTED = [
  "/v2/detection/web_application/dashboard",
  "/v2/services/web_application/dashboard",
  "/v2/detection/bot/dashboard",
  "/v2/services/bot/dashboard",
];

function matchesPrefix(pathname, prefix) {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function isSiteSelectorLockedPath(pathname) {
  if (!pathname) return false;
  return LOCKED_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix));
}

/** Hide GlobalSiteSelector when site changes would not update this page's data. */
export function isSiteSelectorHiddenPath(pathname) {
  if (!pathname) return false;
  if (HIDDEN_PREFIXES.some((prefix) => matchesPrefix(pathname, prefix))) {
    return true;
  }
  return HIDDEN_DASHBOARD_NESTED.some((base) => pathname.startsWith(`${base}/`));
}
